let CurrentSubscriptionRecord = {}
var liveHost = 'goodbuygear.com';
var serverBaseUrl = window.location.host == liveHost ? 'https://api.goodbuygear.com' : 'https://api.goodbuygear.com';
var addonBaseUrl = window.location.host == liveHost ? 'https://shopifyapp2.goodbuygear.com' : 'https://shopifyapp2.goodbuygear.com';

function localStorageUpdated(ev) {
    if (ev.originalEvent.key == 'currentCustomerData') {
        const data = JSON.parse(ev.originalEvent.newValue);
        if (!data) return; // ignore empty msg or msg reset
        if (window.location.href.includes('pages/white-glove')) {
            const iframe = document.getElementById('scheduleServiceIframe');
            iframe.contentWindow.postMessage({
                'eventName': 'customerSignedIn',
                'data': {'shopifyCustomerId': data.shopifyCustomerId}
            }, "*");
        }
    }
}

window.addEventListener('message', function (e) {
    if (e.data && e.data['eventName']) {
        const eventName = e.data['eventName'];
        switch (eventName) {
            case 'setIframeHeight':
                const $iframe = jQuery("#" + e.data['elementID'] + 'Iframe');
                let additionalHeight = 200;
                if (e.data['elementID'] == 'scheduleService') {
                    additionalHeight = 0;
                }
                let wrapperElement = document.getElementById(e.data['elementID'] + 'Wrapper');
                wrapperElement.style.visibility = 'visible';

                let elementPendingBox = document.getElementById(e.data['elementID'] + 'PendingBox');
                let initialLoad = false;
                if (elementPendingBox) {
                    initialLoad = elementPendingBox.style.display ? false : true;
                    elementPendingBox.style.display = 'none';
                }
                if (e.data && e.data['height']) {
                    $iframe.height(e.data['height'] + additionalHeight);
                    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
                    if (iOS && !initialLoad) {
                        $('html, body').animate({scrollTop: $("#scheduleServiceWrapper").offset().top - 210}, 1);
                    }
                }
                break;
            case 'screenChanged':
                if (window.location.hash != '#estimator') {
                    if (e.data['elementID'] == 'scheduleService') {
                        $([document.documentElement, document.body]).animate({
                            scrollTop: $("#scheduleServiceWrapper").offset().top - 170
                        }, 500);
                    }
                }
                break;
            case 'customAction':
                if (e.data['methodName'] && window[e.data.methodName]) {
                    const timeout = e.data.timeout ? e.data.timeout : 0;
                    setTimeout(function () {
                        window[e.data.methodName](e.data.methodData || {});
                    }, timeout);
                }
                break;
        }
    } else {
        return
    }
}, false);

function addToFavoritesChange(evt, data) {
    evt.preventDefault();

    const target = evt.target;

    if (customer.id) {
        let requestData = {
            type: 'post',
            data: {
                ShopifyProductID: data.product_id,
                "Type": "Favorites",
                ShopifyCustomerID: customer.id
            },
            success: function (response) {
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
            }
        }

        if (!target.classList.contains('active')) { /* add to favorites */
            requestData.url = serverBaseUrl + '/subscriptions';

            const webhook_data = {
                product_name: data.product_name,
                product_brand: data.product_brand,
                product_id: data.product_id,
                product_price: data.product_price,
                customer_first_name: customer.first_name,
                customer_email: customer.email
            };

            
            console.log('requestData', requestData);
            $.ajax(requestData).then(function (response) {
                console.log('response', response);
                target.classList.add('active');

                jQuery.ajax({
                    type: 'POST',
                    async: true,
                    data: webhook_data,
                    dataType: 'json',
                    url: 'https://hooks.zapier.com/hooks/catch/1840519/o7pidlt/',
                    success: function() {
                    },
                    error: function () {
                    }
                });
            }).catch(function (err) {
                if (err.responseJSON.errorMessageData.subscriptionID) {
                    console.log('if error', err);
                    /* if record already exists */
                    requestData.url = serverBaseUrl + '/update-subscription-status/' + encodeURIComponent(err.responseJSON.errorMessageData.subscriptionID);
                    requestData.type = 'patch';
                    requestData.data.Deleted = 'false';
                    requestData.data.Status = 'Active';
                    $.ajax(requestData).then(function (response) {
                        target.classList.add('active');

                        jQuery.ajax({
                            type: 'POST',
                            async: true,
                            data: webhook_data,
                            dataType: 'json',
                            url: 'https://hooks.zapier.com/hooks/catch/1840519/o7pidlt/',
                            success: function() {
                            },
                            error: function () {
                            }
                        });
                    });
                }
            });
        } else {  /* remove from favorites */
            requestData.url = serverBaseUrl + '/update-subscription-status/';
            requestData.type = 'patch';
            requestData.data.Deleted = 'true';
            $.ajax(requestData).then(function (response) {
                target.classList.remove('active');
            });
        }
    } else {
        alert('Please create an account or log in');
    }
}

function popupCreateAccount(e) {
    e.preventDefault();

    $.magnificPopup.open({
        items: {
            src: '#welcome_form4',
            type: 'inline',
            fixedContentPos: true,
            preloader: false,
            modal: true
        },
        callbacks: {
            close: function() {
                $('#welcome_form4 .login-wrapper').hide();
                $('#welcome_form4 .welcome-form-wrapper').show();
                $('#welcome_form4 .login-wrapper .account-login').addClass('visible');
                $('#welcome_form4 .login-wrapper .account-recovery').removeClass('visible');
            }
        }
    });
}

function popupNotifySubscription(e) {
    e.preventDefault();

    const userEmail = Cookies.get('user_email') || false;

    $('#subscribe_text').text($('#search_input').val());

    $.magnificPopup.open({
        items: {
            src: '#welcome_form7',
            type: 'inline',
            fixedContentPos: true,
            preloader: false,
            modal: true
        }
    });

    if (userEmail) {
        $('#email7').val(userEmail);
        $('#email7').addClass('form-field-filled');
    }
}

function changeToggleButton(evt, data) {
    const shopifyCustomerId = data.shopifyCustomerId;
    const textToMatch = data.textToMatch;
    const checked = evt.target.checked || false;

    if (!textToMatch) {
        return;
    }

    if (shopifyCustomerId) {
        let requestData = {
            type: 'post',
            data: {
                TextToMatch: textToMatch,
                "Type": "InStock",
                ShopifyCustomerID: shopifyCustomerId
            },
            success: function (response) {
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
            }
        }

        if (checked) { /* subscribe */
            requestData.url = serverBaseUrl + '/subscriptions';

            $.ajax(requestData).then(function (response) {
                CurrentSubscriptionRecord = response.data || {};
            }).catch(function (err) {
                if (err.responseJSON.errorMessageData.subscriptionID) {
                    /* if subscription already exists */
                    CurrentSubscriptionRecord = {_id: err.responseJSON.errorMessageData.subscriptionID};
                    requestData.url = serverBaseUrl + '/update-subscription-status/' + encodeURIComponent(CurrentSubscriptionRecord._id);
                    requestData.type = 'patch';
                    requestData.data.Deleted = 'false';

                    $.ajax(requestData).then(function (response) {
                    });
                }
            });
        } else { /* unsubscribe*/
            requestData.url = serverBaseUrl + '/update-subscription-status/' + encodeURIComponent(CurrentSubscriptionRecord._id);
            requestData.type = 'patch';
            requestData.data.Deleted = 'true';

            $.ajax(requestData).then(function (response) {
                const toggleSubscriptionLabels = $('.toggle-button[data-searchterm="' + textToMatch + '"] .toggle-button-label');

                $(".toggle-button .toggle-button-label").html("Notify me when   &#8220;" + textToMatch + "&#8221; is in stock");
            });
        }
    } else {
        if (checked) { /* subscribe */
            popupNotifySubscription(evt);
        } else { /* unsubscribe*/
            const userEmail = Cookies.get('user_email') || false;
            if (userEmail) {
                const requestData = {
                    type: 'patch',
                    url: serverBaseUrl + '/update-subscription-status/' + encodeURIComponent(CurrentSubscriptionRecord._id),
                    data: {
                        TextToMatch: textToMatch,
                        Type: "InStock",
                        Email: userEmail,
                        Deleted: 'true'
                    },
                    success: function (response) {
                    },
                    error: function (XMLHttpRequest, textStatus, errorThrown) {
                    }
                }

                $.ajax(requestData).then(function (response) {
                    const toggleSubscriptionLabels = $('.toggle-button[data-searchterm="' + textToMatch + '"] .toggle-button-label');
                    $(".toggle-button .toggle-button-label").html("Notify me when   &#8220;" + textToMatch + "&#8221; is in stock");
                });
            }
        }
    }
}

function checkIfSubscriptionExists(data) {
    const shopifyCustomerId = data.shopifyCustomerId || '';
    const textToMatch = data.textToMatch;

    if (!textToMatch) {
        return;
    }

    if (shopifyCustomerId) {
        $.ajax({
            type: 'get',
            url: serverBaseUrl + '/searh-subscriptions',
            data: {
                TextToMatch: textToMatch,
                "Type": "InStock",
                ShopifyCustomerID: shopifyCustomerId
            },
            success: function (response) {
                if ((response.data || []).length == 1) {
                    CurrentSubscriptionRecord = response.data['0'] || {};

                    if (!CurrentSubscriptionRecord.Deleted) {
                        $(".toggle-button .toggle-button-label").text("You have already subscribed to notifications for this item");
                        $('.toggle-button[data-searchterm="' + textToMatch + '"] input').prop('checked', true);
                    }
                }

                setTimeout(function () {
                    $('.toggle-button[data-searchterm="' + textToMatch + '"]').removeClass('hidden');
                }, 500);
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
                setTimeout(function () {
                    $('.toggle-button[data-searchterm="' + textToMatch + '"]').removeClass('hidden');
                }, 500);
            }
        });
    } else {
        $('.toggle-button[data-searchterm="' + textToMatch + '"]').removeClass('hidden');
    }
}

/**
 * Check if subscription already exists in TUSH
 *
 * @param data 
 * @returns {subscription record}
 */

function checkIfActiveSubscriptionExists(data) {
    const shopifyCustomerId = data.shopifyCustomerId || '';
    const textToMatch = data.textToMatch;

    if (!textToMatch) {
        return;
    }

    if (shopifyCustomerId) {
        $.ajax({
            type: 'get',
            url: serverBaseUrl + '/search-subscriptions',
            data: {
                TextToMatch: textToMatch,
                "Types": ["InStock"],
                ShopifyCustomerID: shopifyCustomerId
            },
            success: function (response) {
                if ((response.data || []).length == 1) {
                    CurrentSubscriptionRecord = response.data['0'] || {};

                    if (!CurrentSubscriptionRecord.Deleted) {
                        $(".toggle-button .toggle-button-label").text("You have already subscribed to notifications for this item");
                        $('.toggle-button[data-searchterm="' + textToMatch + '"] input').prop('checked', true);
                    }
                }

                setTimeout(function () {
                    $('.toggle-button[data-searchterm="' + textToMatch + '"]').removeClass('hidden');
                }, 500);
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
                setTimeout(function () {
                    $('.toggle-button[data-searchterm="' + textToMatch + '"]').removeClass('hidden');
                }, 500);
            }
        });
    } else {
        const userEmail = Cookies.get('user_email') || false;

        if (userEmail) {
            $.ajax({
                type: 'get',
                url: serverBaseUrl + '/search-subscriptions',
                data: {
                    TextToMatch: textToMatch,
                    Types: ["InStock"],
                    Email: userEmail
                },
                success: function (response) {
                    if ((response.data || []).length == 1) {
                        CurrentSubscriptionRecord = response.data['0'] || {};

                        if (!CurrentSubscriptionRecord.Deleted) {
                            $(".toggle-button .toggle-button-label").text("You have already subscribed to notifications for this item");
                            $('.toggle-button[data-searchterm="' + textToMatch + '"] input').prop('checked', true);
                        }
                    }

                    setTimeout(function () {
                        $('.toggle-button[data-searchterm="' + textToMatch + '"]').removeClass('hidden');
                    }, 500);
                },
                error: function (XMLHttpRequest, textStatus, errorThrown) {
                    setTimeout(function () {
                        $('.toggle-button[data-searchterm="' + textToMatch + '"]').removeClass('hidden');
                    }, 500);
                }
            });
        } else {
            setTimeout(function () {
                $('.toggle-button[data-searchterm="' + textToMatch + '"]').removeClass('hidden');
            }, 500);
        }
    }
}

$(document).on('click', '#start7', function (e) {
    e.preventDefault();

    const textToMatch = $('#subscribe_text').text();
    let errors = false;
    const user_email = $('#email7').val();

    if (!textToMatch) {
        $.magnificPopup.close();

        return;
    }

    if (!validateEmail(user_email)) {
        $('#email7').parents('.form-field').addClass('error');
        errors = true;
    } else {
        $('#email7').removeClass('form-field-error').parents('.form-field').removeClass('error');
    }

    if (!errors) {
        Cookies.set('user_email', user_email, {expires: 365, path: '/'});

        let requestData = {
            type: 'post',
            data: {
                TextToMatch: textToMatch,
                Type: "InStock",
                Email: user_email
            },
            success: function (response) {
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
            }
        }

        requestData.url = serverBaseUrl + '/subscriptions';

        $.ajax(requestData).then(function (response) {
            CurrentSubscriptionRecord = response.data || {};
        }).catch(function (err) {
            if (err.responseJSON.errorMessageData.subscriptionID) {
                /* if subscription already exists */
                CurrentSubscriptionRecord = {_id: err.responseJSON.errorMessageData.subscriptionID};
                requestData.url = serverBaseUrl + '/update-subscription-status/' + encodeURIComponent(CurrentSubscriptionRecord._id);
                requestData.type = 'patch';
                requestData.data.Deleted = 'false';

                $.ajax(requestData).then(function (response) {
                });
            }
        });

        $.magnificPopup.close();
    }
});

function sendDataToGTM(params) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(params.dataLayer || {});
}
function updateServiceConfirmationData(params) {
    sessionStorage.setItem('serviceConfirmationEmailData', JSON.stringify((({serviceAddress, serviceTime, confirmationEmailAddress, serviceCalendarLink, serviceType, date}) => ({serviceAddress, serviceTime, confirmationEmailAddress, serviceCalendarLink, serviceType, date}))(params)));
}
function addProductToCart(params) {
    const iframe = document.getElementById('subscriptionsListIframe');
    
    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            quantity: 1,
            id: params.ShopifyProductVariantID
        },
        dataType: 'json'
    }).done(function(msg) {
        const header = jQuery('.site-header-wrapper');

        if (iframe) {
            iframe.contentWindow.postMessage({
                'eventName': 'displayNotificationFromShopify',
                'messageType': 'success',
                'messageText': 'Product added to cart'
            }, "*");
        } else {
            alert( 'Product added to cart');
        }

        jQuery.ajax({
            type: 'GET',
            url: '/cart.js',
            dataType: 'json'
        }).done(function (response) {
            header.trigger('cartcount:update', { response: response });
        });
    }).fail(function(xhr, status, error) {
        const responseText = JSON.parse(xhr.responseText || '{}');

        if (responseText.description) {
            if (iframe) {
                iframe.contentWindow.postMessage({
                    'eventName': 'displayNotificationFromShopify',
                    'messageType': 'warning',
                    'messageText': responseText.description
                }, "*");
            } else {
                alert(responseText.description);
            }
        }
    });
}

$('#create_customer2').submit(function(e) {
    let errors = false;
    const register_password = $('#register_password').val();
    const register_email = $('#register_email').val();

    console.log(register_password, register_email);

    if (register_password.length < 12) {
        $('#register_password').parents('.form-field').addClass('error');
        errors = true;
    } else if (!validatePassword(register_password)) {
        $('#register_password').parents('.form-field').addClass('error');
        errors = true;
    } else {
        $('#register_password').removeClass('form-field-error').parents('.form-field').removeClass('error');
    }

    if (!validateEmail(register_email)) {
        $('#register_email').parents('.form-field').addClass('error');
        errors = true;
    } else {
        $('#register_email').removeClass('form-field-error').parents('.form-field').removeClass('error');
    }

    if (errors) {
        e.preventDefault();
    } else {
        Cookies.set('redirect', document.location.href, {expires: 365, path: '/'});
    }
});

$('#customer_login4').submit(function(e) {
    Cookies.set('redirect', document.location.href, {expires: 365, path: '/'});
});

if (Cookies.get('redirect')) {
    if (!isChallenge() && !isRegister() && !isLogin()) {
        const redirect_link = Cookies.get('redirect');
        Cookies.set('redirect', '', {expires: 365, path: '/'});
        document.location = redirect_link;
    }
}

$(document).on('click', '.login_toggle', function (e) {
    e.preventDefault();

    $(this).parents('.welcome-form').find('.welcome-form-wrapper').hide();
    $(this).parents('.welcome-form').find('.login-wrapper').show();
});

$(document).on('click', '.create_toggle', function (e) {
    e.preventDefault();

    $(this).parents('.welcome-form').find('.login-wrapper').hide();
    $(this).parents('.welcome-form').find('.welcome-form-wrapper').show();
});

$(document).on('click', '.welcome-form [data-login-toggle]', function (e) {
    e.preventDefault();

    $(this).parents('.welcome-form').find('.account-login').toggleClass('visible');
    $(this).parents('.welcome-form').find('.account-recovery').toggleClass('visible');
});

$('.welcome-form .form-field .form-field-input').on('blur', function() {
    if ($(this).val() != '') {
        $(this).addClass('form-field-filled');
    } else {
        $(this).removeClass('form-field-filled');
    }
});

$('#create_customer').on('submit', function(e) {
    let errors = false;
    const register_password = $('#register_password').val();
    const register_email = $('#register_email').val();

    if (register_password.length < 12) {
        $('#register_password').parents('.form-field').addClass('error');
        errors = true;
    } else if (!validatePassword(register_password)) {
        $('#register_password').parents('.form-field').addClass('error');
        errors = true;
    } else {
        $('#register_password').removeClass('form-field-error').parents('.form-field').removeClass('error');
    }

    if (!validateEmail(register_email)) {
        $('#register_email').parents('.form-field').addClass('error');
        errors = true;
    } else {
        $('#register_email').removeClass('form-field-error').parents('.form-field').removeClass('error');
    }

    if (errors) {
        e.preventDefault();
    }
});

function getCustomerSubscriptions(data) {
    return new Promise(function (resolve, reject) {
        const shopifyCustomerId = data.shopifyCustomerId;

        if (shopifyCustomerId) {
            $.ajax({
                type: 'get',
                url: serverBaseUrl + '/search-subscriptions',
                data: {
                    all: true,
                    Statuses: ['Active'],
                    "Types": ["Favorites"],
                    ShopifyCustomerSubscriptions: true,
                    ShopifyCustomerID: shopifyCustomerId
                },
                success: function (response) {
                    const records = {
                        records: response.data ? response.data : [],
                        dateReceivedAt: new Date()
                    }

                    resolve(records.records);
                },
                error: function (XMLHttpRequest, textStatus, errorThrown) {
                    reject('request error');
                }
            });
        } else {
            reject('not logged in');
        }
    });
}

function isProduct () {
    return window.location.href.indexOf("/products") > -1 ? true : false;
}

function isCareers () {
    return window.location.href.indexOf("/careers") > -1 ? true : false;
}

function isSearch () {
    return window.location.href.indexOf("/search") > -1 ? true : false;
}

function isChallenge () {
    return window.location.href.indexOf("/challenge") > -1 ? true : false;
}

function isRegister () {
    return window.location.href.indexOf("/account/register") > -1 ? true : false;
}

function isLogin () {
    return window.location.href.indexOf("/account/login") > -1 ? true : false;
}

function isBabyRegistry () {
    return window.location.href.indexOf("/pages/baby-registry") > -1 ? true : false;
}

function isTerms () {
    return window.location.href.indexOf("/pages/good-buy-gear-seller-terms") > -1 ? true : false;
}

function isBlogs () {
    return window.location.href.indexOf("/blogs/") > -1 ? true : false;
}

function validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

function validatePassword(password) {
    const re = /[0-9]/;
    const re2 = /[a-zA-Z]/;
    const re3 = /[!@#$%^&*()_+,./'"\]\\[;]/;
    if (re.test(String(password)) && re2.test(String(password)) && re3.test(String(password))) {
        return true;
    } else {
        return false;
    }
}

const mobileMenuLinks = document.querySelectorAll('.mobile-nav-link[data-target]');

mobileMenuLinks.forEach(menuLink => {
  menuLink.addEventListener('click', (event) => {
    event.preventDefault();

    const mobileSubmenus = document.querySelectorAll('.mobile-nav-submenu');
    mobileSubmenus.forEach(submenu => { if (submenu.dataset.level == menuLink.dataset.level) submenu.classList.remove('is-opened') });

    const target = document.getElementById(menuLink.dataset.target);
    if (target) target.classList.add('is-opened');
  });
});

const mobileMenuBackLinks = document.querySelectorAll('.mobile-nav-back');

mobileMenuBackLinks.forEach(menuBackLink => {
  menuBackLink.addEventListener('click', (event) => {
    event.preventDefault();

    menuBackLink.closest('.mobile-nav-submenu').classList.remove('is-opened');
  });
});

const sellerFaqs = document.querySelectorAll('[data-seller-landing-accordion-item-title]');

sellerFaqs.forEach(faq => {
  faq.addEventListener('click', () => {
    faq.parentElement.classList.toggle('open');
  });
});

const sellerTermsLinks = document.querySelectorAll('[data-terms-section]');

sellerTermsLinks.forEach(link => {
  link.addEventListener('click', () => {
    const section = document.getElementById(link.dataset.termsSection);
    if (!section) return;

    const headerHeight = document.querySelector('.site-header').offsetHeight + 20;
    const offset = section.getBoundingClientRect().top + window.scrollY - headerHeight;

    window.scrollTo({ top: offset, left: 0, behavior: 'smooth' });
  });
});

const scrollToElements = document.querySelectorAll('[data-scroll-element]');
scrollToElements.forEach(element => {
  element.addEventListener('click', (event) => {
    event.preventDefault();
    
    const section = document.querySelector(element.dataset.scrollElement);
    if (!section) return;

    const headerHeight = document.querySelector('.site-header').offsetHeight + 20;
    const offset = section.getBoundingClientRect().top + window.scrollY - headerHeight;

    window.scrollTo({ top: offset, left: 0, behavior: 'smooth' });
  });
});



const fullPrice = document.querySelector('[data-product-full-price]');
if (fullPrice) {
  if (document.querySelector('.desc_original_link a')) {
    const amazonHref = document.querySelector('.desc_original_link a').getAttribute('href');
    document.querySelector('[data-product-full-price] a').setAttribute('href', amazonHref);
    fullPrice.classList.add('show');
  }
}

if (isProduct()) {
  $('#notify-me').on('submit', function(e) {
      e.preventDefault();

      const _this = this;

      jQuery.ajax({
          type: 'POST',
          async: true,
          data: $('#notify-me').serialize(),
          dataType: 'json',
          url: 'https://hooks.zapier.com/hooks/catch/1840519/zkappl/',
          success: function() {
              $(_this).addClass('success');
          },
          error: function () {
          }
      });
      return false;
  });
}

function isProduct () {
  return window.location.href.indexOf("/products") > -1 ? true : false;
}

if (isProduct()) {
  tippy('.tippy', {
    placement: 'top',
    animation: 'shift-toward',
    duration: 600,
    arrow: true,
    livePlacement: false,
    theme: 'goodbuygear',
  });
  
  tippy('#price-drop__click2', {
    html: document.querySelector('#price-drop__tip2'),
    arrow: true,
    animation: 'shift-toward',
    distance: 15,
    trigger: 'click',
    interactive: true,
    livePlacement: false,
    theme: 'goodbuygear--price-drop',
    onShown: function (instance) {
      const form = document.getElementById('price-drop');
      if (form && !form.dataset.eventBound) {
        form.dataset.eventBound = 'true';
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          const formData = new FormData(form);
          fetch('https://hooks.zapier.com/hooks/catch/1840519/zwqvxg/', {
            method: 'POST',
            body: formData,
          })
            .then(response => {
              if (response.ok) {
                form.classList.add('success');
              } else {
                throw new Error('Failed to submit form');
              }
            })
            .catch(error => {
              console.error('Error:', error);
            });
        });
      }
    }
  });
  
  tippy('#price-drop__click3', {
    html: document.querySelector('#price-drop__tip3'),
    arrow: true,
    animation: 'shift-toward',
    distance: 15,
    trigger: 'click',
    interactive: true,
    livePlacement: false,
    theme: 'goodbuygear--price-drop',
  });
}
  
class ConditionNotes extends HTMLElement {
  constructor() {
    super();

    this.btn = this.querySelector('.btn-learnMore');
    
    this.btn.addEventListener('click', (event) => {
      event.preventDefault();
      if(this.querySelector('[data-condition-text]').classList.contains('hide')) {
        this.querySelector('[data-condition-text]').classList.remove('hide');
      } else {
        this.querySelector('[data-condition-text]').classList.add('hide');
      }
    });
  }
}

customElements.define('condition-notes', ConditionNotes);

const filterRemoveItems = document.querySelectorAll('.filter-item--remove a');
filterRemoveItems.forEach(filterRemoveItem => {
  filterRemoveItem.addEventListener('click', (event) => {
    event.preventDefault();

    const parsedUrl = new URL(filterRemoveItem.href);
    location.href = `${parsedUrl.origin}${parsedUrl.pathname}?${jQuery.param(Shopify.queryParams).replace(/\+/g, '%20')}`;
  });
});

$(document).ready(function() {

    if(document.querySelector('[data-filter-price-range]')) {
    
        const minNumber = document.querySelector('[data-filter-price-range]').getAttribute('min');
        const maxNumber = document.querySelector('[data-filter-price-range]').getAttribute('max');
        const fromNumber = document.querySelector('[data-filter-price-range]').getAttribute('from');
        const toNumber = document.querySelector('[data-filter-price-range]').getAttribute('to');
        $('[data-filter-price-range]').ionRangeSlider({
            type: "double",
            min: minNumber,
            max: maxNumber,
            from: fromNumber ? fromNumber : minNumber,
            to: toNumber ? toNumber : maxNumber,
            step: 1,
            grid: true,
            force_edges: false,
            hide_min_max: false,
            hide_from_to: false,
            block: false,
            prefix: "$",
            onStart: function (data) {
                $('.removeFilterPrice').remove();
            },
        });
        
        const rangeNames = [];
        document.querySelectorAll('[data-filter-range]').forEach(el => {
            rangeNames.push(el.name);
        });
        $('body').on('change', '[data-filter-price-range]', function (e) {
            e.preventDefault();

            Shopify.queryParams = {};

            // We should only update Shopify.queryParams with grid/list view, sortby and view
            // so we'll create an allow-list of params
            const allowedQueryParams = ['view', 'sort_by', 'grid_list'];
            const queryPairs = location.search.substr(1).split('&');
                if (location.search.length) {
                queryPairs.forEach(query => {
                    const queryKeyValue = query.split('=');
                    if (queryKeyValue.length > 1 && allowedQueryParams.includes(queryKeyValue[0])) {
                        Shopify.queryParams[decodeURIComponent(queryKeyValue[0])] = decodeURIComponent(queryKeyValue[1]);
                    }
                });
            }
        
            var price_value = $(this).val(),
                price_min = price_value.split(';')[0],
                price_max = price_value.split(';')[1];
        
            $('[name="filter.v.price.gte"]').val(price_min);
            $('[name="filter.v.price.lte"]').val(price_max);
        
            let searchParameters;
            const currentSearch = window.location.search.replace('?', '');
            const formData = new FormData($(this).closest('form')[0]);
            const newSearch = new URLSearchParams(formData).toString();

            // Filter through current search string to see if price range input already exists,
            // if it does, create new string without current price range parameters
            const splitCurrentSearch = currentSearch.split('&');
            let filteredCurrentSearch = splitCurrentSearch.filter(search => {
                if (search.includes(rangeNames[0]) || search.includes(rangeNames[1])) {
                    return false;
                }
                return true;
            });
            filteredCurrentSearch = filteredCurrentSearch.join('&');

            // If current search parameters exist, append new search parameters
            // on to existing parameters
            if (filteredCurrentSearch.length > 0) {
                searchParameters = `${filteredCurrentSearch}&${newSearch}`;
            } else {
                searchParameters = `${newSearch}`;
            }

            const shopifyQueryParams = Object.entries(Shopify.queryParams);
            let shopifyQueries = [];
            shopifyQueryParams.forEach(query => {
            // Make sure we're not duplicating any search parameters
            if (!searchParameters.includes(query[0]) && this.allowedQueryParams.includes(query[0])) {
                shopifyQueries.push(query.join('='));
            }
            });
            shopifyQueries = shopifyQueries.join('&');
            let urlQueryString = '';
            if (shopifyQueries && searchParameters) {
                urlQueryString = `?${searchParameters}&${shopifyQueries}`;
            } else if (searchParameters && !shopifyQueries) {
                urlQueryString = `?${searchParameters}`;
            } else {
                urlQueryString = `?${shopifyQueries}`;
            }
            window.location.search = urlQueryString;
            // $(this).closest('form').submit();
        })
    }

    if(document.querySelector('.fav-btn'))
      {
        getCustomerSubscriptions({ shopifyCustomerId: customer.id })
        .then(function (records) {
          $.each(records, function (key, record) {
            $('.fav-btn[product-id="' + record.ShopifyProductID + '"]').addClass(
              'active'
            );
          });
        })
        .catch(function () {});
      }
  });

var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
};

function getCookie(cname) {
    var name = cname+"=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
        c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
        }
    }
    return false;
}

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  document.cookie = cname + "=" + cvalue + ";expires=" + d.toUTCString() + ";path=/";
}

function delete_cookie( name ) {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/";
}

// Gear Finder

class StaticGearFinder {
  constructor(section) {
    var _this = this;

    this.section = JSON.parse(document.querySelector('[data-section-type="static-gear-finder"]').textContent);

    this.banners = this.section.banners;
    this.children = [];
    this.childrenIndex = 1;
    this.searchProgress = false;
    this.searchChanged = true;
    this.zip = 80002;
    this.categories = [];
    this.age0_3m = [
      {name: 'Strollers', id: 'gear-strollers', active: false},
      {name: 'Car Seats', id: 'gear-car-seats', active: false},
      {name: 'Nursing & Feeding', id: 'gear-nursing-feeding', active: false},
      {name: 'Bath & Diapering', id: 'gear-bath-diapering', active: false},
      {name: 'Carriers', id: 'gear-carriers', active: false},
      {name: 'Sleep', id: 'gear-sleep', active: false},
      {name: 'Nursery', id: 'gear-nursery', active: false},
      {name: 'Infant Activity', id: 'gear-infant-activity', active: false},
      {name: 'Toys', id: 'gear-toys-learnings', active: false},
    ];
    this.age3_12m = [
      {name: 'Strollers', id: 'gear-strollers', active: false},
      {name: 'Feeding', id: 'gear-feeding', active: false},
      {name: 'Bath & Diapering', id: 'gear-bath-diapering', active: false},
      {name: 'Carriers', id: 'gear-carriers', active: false},
      {name: 'Sleep', id: 'gear-sleep', active: false},
      {name: 'Furniture & Decor', id: 'gear-furniture-decor', active: false},
      {name: 'Infant Activity', id: 'gear-infant-activity', active: false},
      {name: 'Toys', id: 'gear-toys-learnings', active: false},
      {name: 'Safety', id: 'gear-safety', active: false},
    ];
    this.age12_36m = [
      {name: 'Strollers', id: 'gear-strollers', active: false},
      {name: 'Feeding', id: 'gear-feeding', active: false},
      {name: 'Potty Training', id: 'gear-potty-training', active: false},
      {name: 'Bedding', id: 'gear-bedding', active: false},
      {name: 'Sports & Outdoors', id: 'gear-sport-outdoor', active: false},
      {name: 'Toys & Interactive Play', id: 'gear-toys-active-play', active: false},
      {name: 'Safety', id: 'gear-safety', active: false},
      {name: 'Car Seats', id: 'gear-car-seats', active: false},
    ];
    this.age3_5y = [
      {name: 'Travel', id: 'gear-travel', active: false},
      {name: 'Car Seats', id: 'gear-car-seats', active: false},
      {name: 'Feeding', id: 'gear-feeding', active: false},
      {name: 'Home & Playroom', id: 'gear-playroom', active: false},
      {name: 'Sports & Outdoors', id: 'gear-sport-outdoor', active: false},
      {name: 'Toys & Learnings', id: 'gear-toys-learnings', active: false},
    ];
    this.age5_9y = [
      {name: 'Toys & Learnings', id: 'gear-toys-learnings', active: false},
      {name: 'Sports & Outdoors', id: 'gear-sport-outdoor', active: false},
      {name: 'Travel', id: 'gear-travel', active: false},
      {name: 'Booster Seats', id: 'gear-booster-seats', active: false},
      {name: 'Home & Playroom', id: 'gear-playroom', active: false},
    ];
    this.age10y = [
      {name: 'Toys & Learnings', id: 'gear-toys-learnings', active: false},
      {name: 'Sports & Outdoors', id: 'gear-sport-outdoor', active: false},
      {name: 'Travel', id: 'gear-travel', active: false},
      {name: 'Home & Playroom', id: 'gear-playroom', active: false},
    ];

    this.$document = $(document);

    this.$gearLoading = $('[data-gear-finder-loading]');

    this.$quizSteps = $('[data-gear-finder-quiz-steps]');
    this.$quizProgress = $('[data-gear-finder-quiz-progress]');

    this.$quizAddChild = $('[data-gear-finder-quiz-add-child]');
    this.$quizChildren = $('[data-gear-finder-quiz-children]');
    this.$quizChildrenNames = $('[data-gear-finder-quiz-children-names]');
    this.$quizChildrenNamesList = $('[data-gear-finder-quiz-children-names-list]');
    this.$quizNext1 = $('[data-gear-finder-quiz-next-1]');
    this.$quizH3 = $('[data-gear-finder-quiz-h3]');

    this.$quizChildrenList = $('[data-gear-finder-quiz-children-list]');
    this.$quizBack2 = $('[data-gear-finder-quiz-back-2]');
    this.$quizNext2 = $('[data-gear-finder-quiz-next-2]');

    this.$quizBack3 = $('[data-gear-finder-quiz-back-3]');
    this.$quizNext3 = $('[data-gear-finder-quiz-next-3]');
    this.$quizInfoName = $('[data-gear-finder-quiz-info-name]');
    this.$quizInfoEmail = $('[data-gear-finder-quiz-info-email]');
    this.$quizInfoZip = $('[data-gear-finder-quiz-info-zip]');
    this.$customer = this.$document.find('#CurrentCustomerID');

    this.$quizBack4 = $('[data-gear-finder-quiz-back-4]');
    this.$quizNext4 = $('[data-gear-finder-quiz-next-4]');
    this.$quizCategories = $('[data-gear-finder-quiz-categories]');

    this.$gearResultsWrapper = $('[data-gear-finder-results-wrapper]');
    this.$gearCount = $('[data-gear-finder-results-count]');
    this.$gearChildSelector = $('[data-gear-finder-results-child-selector]');
    this.$gearChildSelectorList = $('[data-gear-finder-results-child-selector-list]');
    this.$gearChildSelectorLabel = $('[data-gear-finder-results-child-selector-label]');
    this.$gearChildSelectorAdd = $('[data-gear-finder-results-child-selector-add]');
    this.$gearCategorySelector = $('[data-gear-finder-results-category-selector]');
    this.$gearCategorySelectorList = $('[data-gear-finder-results-category-selector-list]');
    this.$gearCategorySelectorLabel = $('[data-gear-finder-results-category-selector-label]');
    this.$gearTags = $('[data-gear-finder-results-tags]');
    this.$gearTagsCategory = $('[data-gear-finder-results-tags-category]');
    this.$gearResults = $('[data-gear-finder-results]');

    this._quizAddChild = this._quizAddChild.bind(this);
    this._quizNext1 = this._quizNext1.bind(this);
    this._quizBack2 = this._quizBack2.bind(this);
    this._quizNext2 = this._quizNext2.bind(this);
    this._quizBack3 = this._quizBack3.bind(this);
    this._quizNext3 = this._quizNext3.bind(this);
    this._quizBack4 = this._quizBack4.bind(this);
    this._quizNext4 = this._quizNext4.bind(this);
    this._validateInfo = this._validateInfo.bind(this);
    this._initTags = this._initTags.bind(this);
    this._getResults = this._getResults.bind(this);
    this._quizShow = this._quizShow.bind(this);

    this.events = [
      this.$quizAddChild.on('click', this._quizAddChild),
      this.$quizNext1.on('click', this._quizNext1),
      this.$quizBack2.on('click', this._quizBack2),
      this.$quizNext2.on('click', this._quizNext2),
      this.$quizBack3.on('click', this._quizBack3),
      this.$quizNext3.on('click', this._quizNext3),
      this.$quizBack4.on('click', this._quizBack4),
      this.$quizNext4.on('click', this._quizNext4),
      this.$quizInfoName.on('change input', this._validateInfo),
      this.$quizInfoEmail.on('change input', this._validateInfo),
      this.$quizInfoZip.on('change input', this._validateInfo),
      this.$gearChildSelectorLabel.on('click', this._gearChildSelectorToggle),
      this.$gearCategorySelectorLabel.on('click', this._gearCategorySelectorToggle),
      this.$gearChildSelectorAdd.on('click', this._quizShow),
    ];

    IMask(this.$quizInfoZip[0], {
      mask: '00000'
    });

    this.$document.on('click', '[data-gear-finder-quiz-child]', function (e) {
      e.preventDefault();

      _this.$quizChildrenList.find('.quiz-child').removeClass('active');
      $(this).addClass('active');

      _this._validateSelectedChild();

      _this.$quizCategories.html('');

      if ($(this).hasClass('expecting')) {
        _this.$quizCategories.html(_this._getAgeCategoriesHtml('age0_3m'));
        _this.categories = _this.age0_3m;
      } else {
        var present_date = new Date();
        var child_date = new Date(_this._parseDate($(this).data('date')));

        var d_time = present_date.getTime() - child_date.getTime();
        var d_months = d_time / (1000 * 3600 * 24 * 30);

        if (d_months < 3) {
          _this.$quizCategories.html(_this._getAgeCategoriesHtml('age0_3m'));
          _this.categories = _this.age0_3m;
        } else if (d_months < 12) {
          _this.$quizCategories.html(_this._getAgeCategoriesHtml('age3_12m'));
          _this.categories = _this.age3_12m;
        } else if (d_months < 36) {
          _this.$quizCategories.html(_this._getAgeCategoriesHtml('age12_36m'));
          _this.categories = _this.age12_36m;
        } else if (d_months < 60) {
          _this.$quizCategories.html(_this._getAgeCategoriesHtml('age3_5y'));
          _this.categories = _this.age3_5y;
        } else if (d_months < 108) {
          _this.$quizCategories.html(_this._getAgeCategoriesHtml('age5_9y'));
          _this.categories = _this.age5_9y;
        } else if (d_months >= 108) {
          _this.$quizCategories.html(_this._getAgeCategoriesHtml('age10y'));
          _this.categories = _this.age10y;
        }
      }
    });

    this.$document.on('change input', '[data-gear-finder-quiz-child-input]', function (e) {
      e.preventDefault();

      _this._validateChildren();
    });

    this.$document.on('click', '[data-gear-finder-quiz-child-name]', function (e) {
      e.preventDefault();

      if (e.target.tagName.toLowerCase() !== 'b') {
        var index = $(this).data('index');

        _this.$quizChildren.find('.quiz-child-row').removeClass('active');
        _this.$quizChildren.find('.quiz-child-row[data-index="' + index + '"]').addClass('active');

        _this.$quizChildrenNamesList.find('.quiz-child-name').removeClass('active');
        $(this).addClass('active');
      }
    });

    this.$document.on('click', '[data-gear-finder-quiz-category]', function (e) {
      e.preventDefault();

      $(this).toggleClass('active');

      _this._validateCategories();
    });

    this.$document.on('click', '[data-gear-finder-quiz-child-remove]', function (e) {
      e.preventDefault();

      var index = $(this).parents('.quiz-child-row').data('index');

      if ($(this).parents('.quiz-child-row').hasClass('active')) {
        _this.$quizChildrenNamesList.find('.quiz-child-name[data-index="' + index + '"]').remove();
        $(this).parents('.quiz-child-row').remove();

        _this.$quizChildrenNamesList.find('.quiz-child-name:first-of-type').addClass('active');
        _this.$quizChildren.find('.quiz-child-row:first-of-type').addClass('active');
      } else {
        _this.$quizChildrenNamesList.find('.quiz-child-name[data-index="' + index + '"]').remove();
        $(this).parents('.quiz-child-row').remove();
      }

      if (_this.$quizChildren.find('.quiz-child-row').length == 1) {
        _this.$quizChildrenNames.removeClass('visible');
      }

      _this._validateChildren();
    });

    this.$document.on('click', '[data-gear-finder-quiz-child-name-remove]', function (e) {
      e.preventDefault();

      var index = $(this).parents('.quiz-child-name').data('index');

      _this.$quizChildren.find('.quiz-child-row[data-index="' + index + '"] [data-gear-finder-quiz-child-remove]').click();
    });

    this.$document.on('click', '[data-gear-finder-results-tags-category] [data-gear-finder-results-tag]', function (e) {
      var _this2 = this;

      e.preventDefault();

      $.each(_this.categories, function(key, category) {
        if (category.name == $(_this2).data('name')) category.active = false;
      });

      _this.searchChanged = true;

      _this._initTags();
      _this._getResults();
    });

    this.$document.on('click', '[data-gear-finder-results-child-selector-list] .gear-finder-selector-item', function (e) {
      var _this2 = this;

      e.preventDefault();

      $.each(_this.children, function(key, child) {
        if (child.name == $(_this2).data('name')) {
          if (child.active == true) {
            child.active = false;
          } else {
            $.each(_this.children, function(key, child2) {
              child2.active = false;
            });
            child.active = true;
          }
        }
      });

      $.each(_this.categories, function(key, category) {
        category.active = false;
      });

      _this.$gearChildSelector.removeClass('open');
      _this.$gearCategorySelector.removeClass('open');

      _this.searchChanged = true;

      _this._initCategories();
      _this._initTags();
      _this._getResults();
    });

    this.$document.on('click', '[data-gear-finder-results-category-selector-list] .gear-finder-selector-item', function (e) {
      var _this2 = this;

      e.preventDefault();

      $.each(_this.categories, function(key, category) {
        if (category.name == $(_this2).data('name')) category.active = !category.active;
      });

      _this.searchChanged = true;

      _this._initTags();
      _this._getResults();
    });

    this.$document.on('mouseup', function(e){
      if (!_this.$gearCategorySelector.is(e.target) && _this.$gearCategorySelector.has(e.target).length === 0) {
        _this.$gearCategorySelector.removeClass('open');
      }
      if (!_this.$gearChildSelector.is(e.target) && _this.$gearChildSelector.has(e.target).length === 0) {
        _this.$gearChildSelector.removeClass('open');
      }
    });

    this.$document.on('click', '.com-button', function (e) {
      e.preventDefault();

      var product_id = parseInt($(this).attr('product-id'));

      if (!Cookies.get('compare')) {
        var compare = [product_id],
          json_compare = JSON.stringify(compare);

        Cookies.set('compare', json_compare, {expires: 1, path: '/'});

        $(this).addClass('active');
      } else {
        var json_compare = Cookies.get('compare'),
          compare = JSON.parse(json_compare);

        if ($.inArray(product_id, compare) > -1) {
          compare = jQuery.grep(compare, function(value) {
            return value != product_id;
          });

          $(this).removeClass('active');
        } else {
          compare.push(product_id);

          $(this).addClass('active');
        }

        json_compare = JSON.stringify(compare);
        Cookies.set('compare', json_compare, {expires: 1, path: '/'});
      }
    });

    _this._init();
  }

  _getAgeCategoriesHtml(age) {
    var ages = {
      age0_3m: [
        {name: 'Strollers', img: '//goodbuygear.com/cdn/shop/files/gear-strollers-v2.svg?v=15643942755165312201', img_hover: '//goodbuygear.com/cdn/shop/files/gear-strollers-hover-v3.svg?v=13280744527158132983'},
        {name: 'Car Seats', img: '//goodbuygear.com/cdn/shop/files/gear-car-seats-v2.svg?v=9388374488436691692', img_hover: '//goodbuygear.com/cdn/shop/files/gear-car-seats-hover-v3.svg?v=9793363668373152519'},
        {name: 'Nursing & Feeding', img: '//goodbuygear.com/cdn/shop/files/gear-nursing-feeding-v2.svg?v=16725398194811063620', img_hover: '//goodbuygear.com/cdn/shop/files/gear-nursing-feeding-hover-v3.svg?v=7860353430268383138'},
        {name: 'Bath & Diapering', img: '//goodbuygear.com/cdn/shop/files/gear-bath-diapering-v2.svg?v=8525149662475248572', img_hover: '//goodbuygear.com/cdn/shop/files/gear-bath-diapering-hover-v3.svg?v=4219244347569970464'},
        {name: 'Carriers', img: '//goodbuygear.com/cdn/shop/files/gear-carriers-v2.svg?v=4236904385680977898', img_hover: '//goodbuygear.com/cdn/shop/files/gear-carriers-hover-v3.svg?v=8453146556085019151'},
        {name: 'Sleep', img: '//goodbuygear.com/cdn/shop/files/gear-furniture-v2.svg?v=15157514426268306910', img_hover: '//goodbuygear.com/cdn/shop/files/gear-furniture-hover-v3.svg?v=6694654872769147725'},
        {name: 'Nursery', img: '//goodbuygear.com/cdn/shop/files/gear-bedding-decor-v2.svg?v=16640618195410743525', img_hover: '//goodbuygear.com/cdn/shop/files/gear-bedding-decor-hover-v3.svg?v=5557569892675501168'},
        {name: 'Infant Activity', img: '//goodbuygear.com/cdn/shop/files/gear-infant-activity-v2.svg?v=273635345199170128', img_hover: '//goodbuygear.com/cdn/shop/files/gear-infant-activity-hover-v3.svg?v=12210644143499745762'},
        {name: 'Toys', img: '//goodbuygear.com/cdn/shop/files/gear-toys-learnings-v2.svg?v=5063239337434847373', img_hover: '//goodbuygear.com/cdn/shop/files/gear-toys-learnings-hover-v3.svg?v=13793937731676623251'}
      ],
      age3_12m: [
        {name: 'Strollers', img: '//goodbuygear.com/cdn/shop/files/gear-strollers-v2.svg?v=15643942755165312201', img_hover: '//goodbuygear.com/cdn/shop/files/gear-strollers-hover-v3.svg?v=13280744527158132983'},
        {name: 'Feeding', img: '//goodbuygear.com/cdn/shop/files/gear-feeding-v2.svg?v=780272', img_hover: '//goodbuygear.com/cdn/shop/files/gear-feeding-hover-v3.svg?v=780272'},
        {name: 'Bath & Diapering', img: '//goodbuygear.com/cdn/shop/t/354/assets/gear-bath-diapering-v2.svg?v=780272', img_hover: '//goodbuygear.com/cdn/shop/files/gear-bath-diapering-hover-v3.svg?v=4219244347569970464'},
        {name: 'Carriers', img: '//goodbuygear.com/cdn/shop/files/gear-carriers-v2.svg?v=4236904385680977898', img_hover: '//goodbuygear.com/cdn/shop/files/gear-carriers-hover-v3.svg?v=8453146556085019151'},
        {name: 'Sleep', img: '//goodbuygear.com/cdn/shop/files/gear-furniture-v2.svg?v=15157514426268306910', img_hover: '//goodbuygear.com/cdn/shop/files/gear-furniture-hover-v3.svg?v=6694654872769147725'},
        {name: 'Furniture & Decor', img: '//goodbuygear.com/cdn/shop/files/gear-furniture-v2.svg?v=15157514426268306910', img_hover: '//goodbuygear.com/cdn/shop/files/gear-furniture-hover-v3.svg?v=6694654872769147725'},
        {name: 'Infant Activity', img: '//goodbuygear.com/cdn/shop/files/gear-infant-activity-v2.svg?v=273635345199170128', img_hover: '//goodbuygear.com/cdn/shop/files/gear-infant-activity-hover-v3.svg?v=12210644143499745762'},
        {name: 'Toys', img: '//goodbuygear.com/cdn/shop/files/gear-toys-learnings-v2.svg?v=5063239337434847373', img_hover: '//goodbuygear.com/cdn/shop/files/gear-toys-learnings-hover-v3.svg?v=13793937731676623251'},
        {name: 'Safety', img: '//goodbuygear.com/cdn/shop/files/gear-safety-v2.svg?v=780272', img_hover: '//goodbuygear.com/cdn/shop/files/gear-safety-hover-v3.svg?v=780272'}
      ],
      age12_36m: [
        {name: 'Strollers', img: '//goodbuygear.com/cdn/shop/files/gear-strollers-v2.svg?v=15643942755165312201', img_hover: '//goodbuygear.com/cdn/shop/files/gear-strollers-hover-v3.svg?v=13280744527158132983'},
        {name: 'Feeding', img: '//goodbuygear.com/cdn/shop/files/gear-feeding-v2.svg?v=780272', img_hover: '//goodbuygear.com/cdn/shop/files/gear-feeding-hover-v3.svg?v=780272'},
        {name: 'Potty Training', img: '//goodbuygear.com/cdn/shop/files/gear-potty-training-v2.svg?v=780272', img_hover: '//goodbuygear.com/cdn/shop/files/gear-potty-training-hover-v3.svg?v=780272'},
        {name: 'Bedding', img: '//goodbuygear.com/cdn/shop/files/gear-bedding-decor-v2.svg?v=16640618195410743525', img_hover: '//goodbuygear.com/cdn/shop/files/gear-bedding-decor-hover-v3.svg?v=5557569892675501168'},
        {name: 'Sports & Outdoors', img: '//goodbuygear.com/cdn/shop/files/gear-sport-outdoor-v2.svg?v=780272', img_hover: '//goodbuygear.com/cdn/shop/files/gear-sport-outdoor-hover-v3.svg?v=780272'},
        {name: 'Toys & Interactive Play', img: '//goodbuygear.com/cdn/shop/files/gear-toys-active-play-v2.svg?v=780272', img_hover: '//goodbuygear.com/cdn/shop/files/gear-toys-active-play-hover-v3.svg?v=780272'},
        {name: 'Safety', img: '//goodbuygear.com/cdn/shop/files/gear-safety-v2.svg?v=780272', img_hover: '//goodbuygear.com/cdn/shop/files/gear-safety-hover-v3.svg?v=780272'},
        {name: 'Car Seats', img: '//goodbuygear.com/cdn/shop/files/gear-car-seats-v2.svg?v=9388374488436691692', img_hover: '//goodbuygear.com/cdn/shop/files/gear-car-seats-hover-v3.svg?v=9793363668373152519'}
      ],
      age3_5y: [
        {name: 'Travel', img: '//goodbuygear.com/cdn/shop/files/gear-travel-v2.svg?v=780272', img_hover: '//goodbuygear.com/cdn/shop/files/gear-travel-hover-v3.svg?v=780272'},
        {name: 'Car Seats', img: '//goodbuygear.com/cdn/shop/files/gear-car-seats-v2.svg?v=9388374488436691692', img_hover: '//goodbuygear.com/cdn/shop/files/gear-car-seats-hover-v3.svg?v=9793363668373152519'},
        {name: 'Feeding', img: '//goodbuygear.com/cdn/shop/files/gear-feeding-v2.svg?v=780272', img_hover: '//goodbuygear.com/cdn/shop/files/gear-feeding-hover-v3.svg?v=780272'},
        {name: 'Home & Playroom', img: '//goodbuygear.com/cdn/shop/files/gear-home-playroom-v2.svg?v=780272', img_hover: '//goodbuygear.com/cdn/shop/files/gear-home-playroom-hover-v3.svg?v=780272'},
        {name: 'Sports & Outdoors', img: '//goodbuygear.com/cdn/shop/files/gear-sport-outdoor-v2.svg?v=780272', img_hover: '//goodbuygear.com/cdn/shop/files/gear-sport-outdoor-hover-v3.svg?v=780272'},
        {name: 'Toys & Learnings', img: '//goodbuygear.com/cdn/shop/files/gear-toys-learnings-v2.svg?v=5063239337434847373', img_hover: '//goodbuygear.com/cdn/shop/files/gear-toys-learnings-hover-v3.svg?v=13793937731676623251'}
      ],
      age5_9y: [
        {name: 'Toys & Learnings', img: '//goodbuygear.com/cdn/shop/files/gear-toys-learnings-v2.svg?v=5063239337434847373', img_hover: '//goodbuygear.com/cdn/shop/files/gear-toys-learnings-hover-v3.svg?v=13793937731676623251'},
        {name: 'Sports & Outdoors', img: '//goodbuygear.com/cdn/shop/files/gear-sport-outdoor-v2.svg?v=780272', img_hover: '//goodbuygear.com/cdn/shop/files/gear-sport-outdoor-hover-v3.svg?v=780272'},
        {name: 'Travel', img: '//goodbuygear.com/cdn/shop/files/gear-travel-v2.svg?v=780272', img_hover: '//goodbuygear.com/cdn/shop/files/gear-travel-hover-v3.svg?v=780272'},
        {name: 'Booster Seats', img: '//goodbuygear.com/cdn/shop/files/gear-car-seats-v2.svg?v=9388374488436691692', img_hover: '//goodbuygear.com/cdn/shop/files/gear-car-seats-hover-v3.svg?v=9793363668373152519'},
        {name: 'Home & Playroom', img: '//goodbuygear.com/cdn/shop/files/gear-home-playroom-v2.svg?v=780272', img_hover: '//goodbuygear.com/cdn/shop/files/gear-home-playroom-hover-v3.svg?v=780272'}
      ],
      age10y: [
        {name: 'Toys & Learnings', img: '//goodbuygear.com/cdn/shop/files/gear-toys-learnings-v2.svg?v=5063239337434847373', img_hover: '//goodbuygear.com/cdn/shop/files/gear-toys-learnings-hover-v3.svg?v=13793937731676623251'},
        {name: 'Sports & Outdoors', img: '//goodbuygear.com/cdn/shop/files/gear-sport-outdoor-v2.svg?v=780272', img_hover: '//goodbuygear.com/cdn/shop/files/gear-sport-outdoor-hover-v3.svg?v=780272'},
        {name: 'Travel', img: '//goodbuygear.com/cdn/shop/files/gear-travel-v2.svg?v=780272', img_hover: '//goodbuygear.com/cdn/shop/files/gear-travel-hover-v3.svg?v=780272'},
        {name: 'Home & Playroom', img: '//goodbuygear.com/cdn/shop/files/gear-home-playroom-v2.svg?v=780272', img_hover: '//goodbuygear.com/cdn/shop/files/gear-home-playroom-hover-v3.svg?v=780272'}
      ]
    };
    var categories = '';

    ages[age].forEach(function (category) {
      categories += '<div class="quiz-category" data-gear-finder-quiz-category>'+
                      '<img src="' + category.img + '" class="quiz-category-icon" alt="' + category.name + '">'+
                      '<img src="' + category.img_hover + '" class="quiz-category-icon-hover" alt="' + category.name + '">'+
                      '<div class="quiz-category-label">' + category.name + '</div>'+
                    '</div>';
    });

    return categories;
  }
  
  _init(input, format) {
    var _this = this;
    var customer_hash = getCookie('customer_hash') || false;
    var customer_id = getCookie('customer_id') || false;
    var gear_name = getCookie('gear_name') || '';
    var gear_email = getCookie('gear_email') || '';

    _this.$quizInfoName.val(gear_name);
    _this.$quizInfoEmail.val(gear_email);

    if (!customer_hash) {
      if (getUrlParameter('hash')) {
        customer_hash = getUrlParameter('hash');
      }
    }

    $.get(`${addonBaseUrl}/api/gear-finder-init`, {
      customer_id: customer_id,
      customer_hash: customer_hash
    }).done(function(data) {
      if (data['children']) {
        if (data['children'].length) {
          _this.$quizChildren.html('');
          _this.$quizChildrenNamesList.html('');
          _this.childrenIndex = 0;

          $.each(data['children'], function(key, child) {
            var child_expecting = '';
            var child_expecting_flag = false;
            var child_active_flag = false;
            var child_remove = '<div class="quiz-child-remove" data-gear-finder-quiz-child-remove>'+
                                  '<svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">'+
                                    '<path fill="#FF5B4F" fill-rule="evenodd" d="M5.306 6.5L0 1.194 1.194 0 6.5 5.306 11.806 0 13 1.194 7.694 6.5 13 11.806 11.806 13 6.5 7.694 1.194 13 0 11.806 5.306 6.5z"></path>'+
                                  '</svg>'+
                                '</div>';

            if (child['expecting'] == 1) {
              child_expecting = 'selected';
              child_expecting_flag = true;
            }

            if (child['active'] == 1) {
              child_active_flag = true;
            }

            _this.$quizChildren.append('<div class="quiz-child-row" data-index="' + _this.childrenIndex + '">'+
                                          '<div class="quiz-child-name">'+
                                            '<div class="quiz-label">Child’s first name</div>'+
                                            '<input type="text" placeholder="Charlie" value="' + child['name'] + '" data-gear-finder-quiz-child-input>'+
                                          '</div>'+
                                          '<div class="quiz-child-expecting">'+
                                            '<div class="quiz-label">Born yet? <span class="tippy" title="This will help us give you the best recommendations possible. All information provided is completely confidential."><img src="//goodbuygear.com/cdn/shop/t/354/assets/question-icon.svg?v=182271138597927344761791050004"></span></div>'+
                                            '<select type="text" placeholder="Select" data-gear-finder-quiz-child-input><option value="born">Born</option><option value="expecting" ' + child_expecting + '>Expecting</option></select>'+
                                          '</div>'+
                                          '<div class="quiz-child-date">'+
                                            '<div class="quiz-label">Date of birth <span class="tippy" title="This will help us give you the best recommendations possible. All information provided is completely confidential."><img src="//goodbuygear.com/cdn/shop/t/354/assets/question-icon.svg?v=182271138597927344761791050004"></span></div>'+
                                            '<input type="text" placeholder="MM/DD/YYYY" value="' + child['date'] + '" data-gear-finder-quiz-child-input>'+
                                          '</div>'+
                                          '<div class="quiz-child-due-date">'+
                                            '<div class="quiz-label">Due date <span class="tippy" title="This will help us give you the best recommendations possible. All information provided is completely confidential."><img src="//goodbuygear.com/cdn/shop/t/354/assets/question-icon.svg?v=182271138597927344761791050004"></span></div>'+
                                            '<input type="text" placeholder="MM/DD/YYYY" value="' + child['due_date'] + '" data-gear-finder-quiz-child-input>'+
                                          '</div>'+ child_remove +
                                        '</div>');

            _this.children.push({name: child['name'], date: child['date'], due_date: child['due_date'], expecting: child_expecting_flag, active: child_active_flag});

            _this.$gearChildSelectorList.append('<div class="gear-finder-selector-item" data-name="' + child['name'] + '" data-date="' + child['date'] + '" data-due-date="' + child['due_date'] + '" data-expecting="' + child_expecting_flag + '">' + child['name'] + '</div>');

            _this.$quizChildrenNamesList.append('<div class="quiz-child-name" data-index="' + _this.childrenIndex + '" data-gear-finder-quiz-child-name><span>Child ' + child['name'] + '</span><b data-gear-finder-quiz-child-name-remove>&#10006;</b></div>');

            _this.childrenIndex++;
          });

          if (data['children'].length > 1) {
            _this.$quizChildrenNames.addClass('visible');
          }

          _this.$quizChildren.find('.quiz-child-row:first-of-type').addClass('active');
          _this.$quizChildrenNamesList.find('.quiz-child-name:first-of-type').addClass('active');

          _this._initCategories();

          _this.$gearResults.html('');

          let categories_html = '';
          let products_count = 0;
          let banner_exists = false;

          if (data.categories?.length) {
            $.each(data.categories, function(key, category) {
              if (category.products?.length) {
                var products_html = '';
                var category_link = '';

                categories_html += `<div class="gear-finder-category">
                                      <div class="gear-finder-category-header">
                                        <div class="gear-finder-category-name">${category['name']}</div>
                                        <div class="gear-finder-category-sort">
                                          <select data-gear-finder-category-sort>
                                            <option value="">Sort By</option>
                                            <option value="created-descending">Newest to Oldest</option>
                                            <option value="created-ascending">Oldest to Newest</option>
                                            <option value="price-ascending">Price: Low to High</option>
                                            <option value="price-descending">Price: High to Low</option>
                                            <option value="title-ascending">A-Z</option>
                                            <option value="title-descending">Z-A</option>
                                          </select>
                                        </div>
                                      </div>
                                      <div class="gear-finder-category-products">`;

                $.each(category.products, function(key, product) {
                  let productHtml = getProductCardHtml(product);

                  // `key == 7` - position of the banner on the results. This banner needs to be placed only on the 8-th position.
                  if (_this.banners[category['name']] && key == 7) {
                    let banner = _this.banners[category['name']];

                    productHtml = `<div class="product-card product-banner"
                                          style="background: url(${banner.background}); background-size: cover; background-position: center;">
                                      <a href="${banner.link}" class="product-banner-wrapper" style="background: url(${banner.content}) no-repeat; background-size: contain; background-position: center;"></a>
                                    </div>`;

                    banner_exists = true;
                  }

                  products_html += productHtml;

                  products_count++;
                });

                const ageGroupMatch = category.url.match(/Age%20Group_(\d+-\d+\s\w+)/);
                const ageGroup = (ageGroupMatch) ? ageGroupMatch[1] : '';

                category_link = `<div class="gear-finder-category-link">
                                  <a href="/collections/${category.handle}?filter.p.m.custom.age_group=${ageGroup}" target="_blank">View All ${category['name']}</a>
                                </div>`;

                categories_html += products_html + '</div>' + category_link + '</div>';
              }

              $.each(_this.categories, function(key, category2) {
                if (category2.name == category['name']) {
                  category2.active = true;
                }
              });
            });
          }

          _this.$gearResults.html(categories_html);

          banner_exists ? _this.$gearCount.text(products_count - 1) : _this.$gearCount.text(products_count);

          if (products_count) {
            _this.$gearResultsWrapper.removeClass('no-results');
          } else {
            _this.$gearResultsWrapper.addClass('no-results');
          }

          $('body').removeClass('gear-finder-quiz-show');

          _this._initTags();

          _this._validateChildren();

          getCustomerSubscriptions({shopifyCustomerId: customer.id}).then(function(records) {
            $.each(records, function(key, record) {
              $('.fav-button[product-id="' + record.ShopifyProductID + '"]').addClass('active');
            });
          }).catch(function() {});
        } else {
          _this._validateChildren();

          location.hash = 'step1';

          $('body').addClass('gear-finder-quiz-show');
        }
      } else {
        _this._validateChildren();

        location.hash = 'step1';

        $('body').addClass('gear-finder-quiz-show');
      }

      $(".gear-finder-quiz .quiz-child-date input").datepicker({
        changeMonth: true,
        changeYear: true,
        dateFormat: 'mm/dd/yy',
        maxDate: "+0D"
      });

      $(".gear-finder-quiz .quiz-child-due-date input").datepicker({
        changeMonth: true,
        changeYear: true,
        dateFormat: 'mm/dd/yy',
        minDate: "+0D"
      });

      var inputElements = document.querySelectorAll(".gear-finder-quiz .quiz-child-date input, .gear-finder-quiz .quiz-child-due-date input");

      inputElements.forEach(function(input) {
        var m = new IMask(input, {
          mask: '00/00/0000'
        });
      });

      tippy('.tippy', {
        placement: 'top',
        animation: 'shift-toward',
        duration: 600,
        arrow: true,
        livePlacement: false,
        theme: 'goodbuygear--large'
      });

      _this.$gearLoading.hide();
    });
  }
  
  _parseDate(date) {
    let format = 'mm/dd/yyyy';
    let parts = date.match(/(\d+)/g);
    let i = 0;
    let fmt = {};

    format.replace(/(yyyy|dd|mm)/g, function(part) { fmt[part] = i++; });

    return new Date(parts[fmt['yyyy']], parts[fmt['mm']]-1, parts[fmt['dd']]);
  }
  
  _validateDate(date) {
    let format = 'mm/dd/yyyy';
    let parts = date.match(/(\d+)/g);
    let i = 0;
    let fmt = {};

    format.replace(/(yyyy|dd|mm)/g, function(part) { fmt[part] = i++; });

    if (parts[fmt['yyyy']] >= 1900 && parts[fmt['mm']] > 0 && parts[fmt['mm']] <= 12 && parts[fmt['dd']] > 0 && parts[fmt['dd']] <= 31)
      return true;
    else
      return false;
  }
  
  _validateChildren() {
    var _this = this;
    var valid = true;

    _this.$quizChildren.find('.quiz-child-row').each(function(index2) {
      var child_valid = true;
      var child_name = $(this).find('.quiz-child-name input').val();
      var child_expecting = $(this).find('.quiz-child-expecting select').val();
      var child_date = $(this).find('.quiz-child-date input').val();
      var child_due_date = $(this).find('.quiz-child-due-date input').val();
      var index = $(this).data('index');

      if (child_name == '') {
        $(this).addClass('invalid');
        valid = false;
        child_valid = false;
        _this.$quizChildrenNamesList.find('.quiz-child-name[data-index="' + index + '"] span').text('Child ' + (index2 + 1));
      } else {
        $(this).removeClass('invalid');
        _this.$quizChildrenNamesList.find('.quiz-child-name[data-index="' + index + '"] span').text(child_name);
      }

      if (child_expecting == 'born') {
        $(this).removeClass('expecting');

        if (child_date == '' || !_this._validateDate(child_date)) {
          $(this).addClass('invalid');
          valid = false;
          child_valid = false;
        } else {
          $(this).removeClass('invalid');
        }
      } else {
        $(this).addClass('expecting');

        if (child_due_date == '' || !_this._validateDate(child_due_date)) {
          $(this).addClass('invalid');
          valid = false;
          child_valid = false;
        } else {
          $(this).removeClass('invalid');
        }
      }

      if (child_valid) {
        _this.$quizChildrenNamesList.find('.quiz-child-name[data-index="' + index + '"]').removeClass('invalid');
      } else {
        _this.$quizChildrenNamesList.find('.quiz-child-name[data-index="' + index + '"]').addClass('invalid');
      }
    });

    if (valid) {
      _this.$quizNext1.removeClass('disabled');
    } else {
      _this.$quizNext1.addClass('disabled');
    }
  }
  
  _validateSelectedChild() {
    var _this = this;
    var valid = false;

    _this.$quizChildrenList.find('.quiz-child').each(function(index) {
      if ($(this).hasClass('active')) {
        valid = true;
      }
    });

    if (valid) {
      _this.$quizNext2.removeClass('disabled');
    } else {
      _this.$quizNext2.addClass('disabled');
    }
  }
  
  _validateInfo() {
    var _this = this;
    var valid = true;

    if (_this.$quizInfoName.val() == '') valid = false;
    if (!_this._validateEmail(_this.$quizInfoEmail.val())) valid = false;

    if (!_this._validZip(_this.$quizInfoZip.val())) valid = false;

    if (valid) {
      _this.$quizNext3.removeClass('disabled');
    } else {
      _this.$quizNext3.addClass('disabled');
    }
  }
  
  _validateCategories() {
    var _this = this;
    var valid = false;

    _this.$quizCategories.find('.quiz-category').each(function(index) {
      if ($(this).hasClass('active')) {
        valid = true;
      }
    });

    if (valid) {
      _this.$quizNext4.removeClass('disabled');
    } else {
      _this.$quizNext4.addClass('disabled');
    }
  }
  
  _validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
  }
  
  _validZip(zip) {
    return /^\d{5}?$/.test(zip);
  }
  
  _quizNext1(event) {
    var _this = this;
    event.preventDefault();

    _this.$quizChildrenList.html('');

    _this.$quizChildren.find('.quiz-child-row').each(function(index) {
      var child_name = $(this).find('.quiz-child-name input').val();
      var child_date = $(this).find('.quiz-child-date input').val();
      var child_due_date = $(this).find('.quiz-child-due-date input').val();
      var child_expecting = $(this).hasClass('expecting');
      var expecting = '';

      if (child_expecting) {
        expecting = 'expecting';
      }

      _this.$quizChildrenList.append('<div class="quiz-child ' + expecting + '" data-gear-finder-quiz-child data-name="' + child_name + '" data-date="' + child_date + '" data-due-date="' + child_due_date + '">' + child_name + '</div>');
    });

    _this.$quizSteps.find('.quiz-step[data-step=1]').hide();
    _this.$quizSteps.find('.quiz-step[data-step=2]').show();
    _this.$quizProgress.css('width', '32%');

    location.hash = 'step2';

    if (_this.$quizChildrenList.find('.quiz-child').length == 1) {
      _this.$quizChildrenList.find('.quiz-child:eq(0)').click();
      _this.$quizNext2.click();
    } else {
      _this._validateSelectedChild();
    }
  }
  
  _quizBack2(event) {
    var _this = this;
    event.preventDefault();

    _this.$quizChildrenList.html('');

    _this.$quizSteps.find('.quiz-step[data-step=2]').hide();
    _this.$quizSteps.find('.quiz-step[data-step=1]').show();
    _this.$quizProgress.css('width', '25%');

    location.hash = 'step1';
  }

  _quizNext2(event) {
    var _this = this;
    var zipCode = getCookie('user_zip') || '';
    event.preventDefault();

    if (zipCode && _this._validZip(zipCode)) {
      _this.$quizInfoZip.val(zipCode);
    }

    _this.$quizSteps.find('.quiz-step[data-step=2]').hide();
    _this.$quizSteps.find('.quiz-step[data-step=3]').show();
    _this.$quizProgress.css('width', '61%');

    location.hash = 'step3';

    _this._validateInfo();
  }

  _quizBack3(event) {
    var _this = this;
    event.preventDefault();

    _this.$quizSteps.find('.quiz-step[data-step=2]').show();
    _this.$quizSteps.find('.quiz-step[data-step=3]').hide();
    _this.$quizProgress.css('width', '32%');

    location.hash = 'step2';

    if (_this.$quizChildrenList.find('.quiz-child').length == 1) {
      _this.$quizBack2.click();
    }
  }
  
  _quizNext3(event) {
    var _this = this;
    event.preventDefault();

    _this.$quizSteps.find('.quiz-step[data-step=3]').hide();
    _this.$quizSteps.find('.quiz-step[data-step=4]').show();
    _this.$quizProgress.css('width', '87%');

    location.hash = 'step4';

    _this._validateCategories();

    setCookie("user_zip", _this.$quizInfoZip.val());
    setCookie("gear_name", _this.$quizInfoName.val());
    setCookie("gear_email", _this.$quizInfoEmail.val());

    _this.$gearChildSelectorList.html('');
    _this.children = [];

    _this.$quizChildrenList.find('.quiz-child').each(function(index) {
      var child_name = $(this).data('name');
      var child_date = $(this).data('date');
      var child_due_date = $(this).data('due-date');
      var child_expecting = $(this).hasClass('expecting');
      var child_active = $(this).hasClass('active');

      if (child_active) {
        _this.$gearChildSelectorList.append('<div class="gear-finder-selector-item active" data-name="' + child_name + '" data-date="' + child_date + '" data-due-date="' + child_due_date + '" data-expecting="' + child_expecting + '">' + child_name + '</div>');
      } else {
        _this.$gearChildSelectorList.append('<div class="gear-finder-selector-item" data-name="' + child_name + '" data-date="' + child_date + '" data-due-date="' + child_due_date + '" data-expecting="' + child_expecting + '">' + child_name + '</div>');
      }

      _this.children.push({name: child_name, date: child_date, due_date: child_due_date, expecting: child_expecting, active: child_active});
    });

    var customer_hash = getCookie('customer_hash') || false;
    var customer_id = getCookie('customer_id') || false;

    $.get(`${addonBaseUrl}/api/gear-finder`, {
      zip: _this.$quizInfoZip.val(),
      children: _this.children,
      categories: [],
      name: _this.$quizInfoName.val(),
      email: _this.$quizInfoEmail.val(),
      customer_id: customer_id,
      customer_hash: customer_hash
    }).done(function(data) {
      if (data['customer_hash'] != '') {
        setCookie('customer_hash', data['customer_hash']);
        setCookie('gear_completed', 'gear-finder-start');
      }
    });
  }
  
  _quizBack4(event) {
    var _this = this;
    event.preventDefault();

    _this.$quizSteps.find('.quiz-step[data-step=3]').show();
    _this.$quizSteps.find('.quiz-step[data-step=4]').hide();
    _this.$quizProgress.css('width', '61%');

    location.hash = 'step3';
  }
    
  _quizNext4(event) {
    var _this = this;
    event.preventDefault();

    _this.$quizSteps.find('.quiz-step[data-step=4]').hide();
    _this.$quizSteps.find('.quiz-step[data-step=5]').show();
    _this.$quizProgress.css('width', '100%');

    location.hash = 'results';

    _this.$gearCategorySelectorList.html('');

    _this.$quizCategories.find('.quiz-category').each(function(index) {
      var category_name = $(this).find('.quiz-category-label').text();
      var category_active = $(this).hasClass('active');


      if (category_active) {
        _this.$gearCategorySelectorList.append('<div class="gear-finder-selector-item active" data-name="' + category_name + '">' + category_name + '</div>');

        $.each(_this.categories, function(key, category) {
          if (category.name == category_name) category.active = true;
        });
      } else {
        _this.$gearCategorySelectorList.append('<div class="gear-finder-selector-item" data-name="' + category_name + '">' + category_name + '</div>');
      }
    });

    _this.searchChanged = true;

    _this._initTags();
    _this._getResults(true);
  }
  
  _initTags(event) {
    var _this = this;

    _this.$gearTagsCategory.html('');
    _this.$gearCategorySelectorList.find('.gear-finder-selector-item').removeClass('active');
    _this.$gearChildSelectorList.find('.gear-finder-selector-item').removeClass('active');

    $.each(_this.categories, function(key, category) {
      if (category.active) {
        _this.$gearTagsCategory.append('<div class="gear-finder-tag" data-name="' + category.name + '" data-gear-finder-results-tag>' + category.name + '</div>');

        _this.$gearCategorySelectorList.find('.gear-finder-selector-item[data-name="' + category.name + '"]').addClass('active');
      }
    });

    $.each(_this.children, function(key, child) {
      if (child.active) {
        _this.$gearChildSelectorList.find('.gear-finder-selector-item[data-name="' + child.name + '"]').addClass('active');
      }
    });
  }

  _initCategories(event) {
    var _this = this;

    _this.categories = [];
    _this.$gearCategorySelectorList.html('');

    $.each(_this.children, function(key, child) {
      if (child.active) {
        if (child.expecting) {
          _this.categories = _this.age0_3m;
        } else {
          var present_date = new Date();
          var child_date = new Date(child.date);

          var d_time = present_date.getTime() - child_date.getTime();
          var d_months = d_time / (1000 * 3600 * 24 * 30);

          if (d_months < 3) {
            _this.categories = _this.age0_3m;
          } else if (d_months < 12) {
            _this.categories = _this.age3_12m;
          } else if (d_months < 36) {
            _this.categories = _this.age12_36m;
          } else if (d_months < 60) {
            _this.categories = _this.age3_5y;
          } else if (d_months < 108) {
            _this.categories = _this.age5_9y;
          } else if (d_months >= 108) {
            _this.categories = _this.age10y;
          }
        }
      }
    });

    $.each(_this.categories, function(key, category) {
      _this.$gearCategorySelectorList.append('<div class="gear-finder-selector-item" data-name="' + category.name + '">' + category.name + '</div>');
    });
  }
  
  _showLoader(event) {
    var _this = this;

    let categories_html = '';

    for (var i = 0; i < 2; i++) {
      categories_html+= `<div class="gear-finder-category card-loader">
                          <div class="gear-finder-category-header">
                            <div class="gear-finder-category-name"><span></span></div>
                          </div>
                          <div class="gear-finder-category-products">
                            <div class="product-card"><div class="image"></div><div class="content"><h3></h3><p></p><p></p><p></p></div></div>
                            <div class="product-card"><div class="image"></div><div class="content"><h3></h3><p></p><p></p><p></p></div></div>
                            <div class="product-card"><div class="image"></div><div class="content"><h3></h3><p></p><p></p><p></p></div></div>
                            <div class="product-card"><div class="image"></div><div class="content"><h3></h3><p></p><p></p><p></p></div></div>
                            <div class="product-card"><div class="image"></div><div class="content"><h3></h3><p></p><p></p><p></p></div></div>
                            <div class="product-card"><div class="image"></div><div class="content"><h3></h3><p></p><p></p><p></p></div></div>
                            <div class="product-card"><div class="image"></div><div class="content"><h3></h3><p></p><p></p><p></p></div></div>
                            <div class="product-card"><div class="image"></div><div class="content"><h3></h3><p></p><p></p><p></p></div></div>
                          </div>
                          <div class="gear-finder-category-link">
                            <span></span>
                          </div>
                        </div>`;
    }

    _this.$gearResults.html(categories_html);
  }
  
  _getResults(event) {
    var _this = this;
    var categories = [];
    var customer_hash = getCookie('customer_hash') || false;
    var customer_id = getCookie('customer_id') || false;

    $.each(_this.categories, function(key, category) {
      if (category.active) {
        categories.push(category.name);
      }
    });

    if (_this.searchProgress == true) return;

    _this.searchProgress = true;
    _this.searchChanged = false;
    _this._showLoader();

    $.get(`${addonBaseUrl}/api/gear-finder`, {
      zip: getCookie('user_zip') || '',
      submitted: event || false,
      children: _this.children,
      categories: categories,
      name: _this.$quizInfoName.val(),
      email: _this.$quizInfoEmail.val(),
      customer_id: customer_id,
      customer_hash: customer_hash
    }).done(function(data) {
      _this.$gearResults.html('');

      let categories_html = '';
      let products_count = 0;
      let banner_exists = false;

      if (data['customer_hash'] != '') {
        setCookie('customer_hash', data['customer_hash']);
      }

      if (data.categories?.length) {
        $.each(data.categories, function(key, category) {
          if (category.products?.length) {
            var products_html = '';
            var category_link = '';

            categories_html += `<div class="gear-finder-category">
                                  <div class="gear-finder-category-header">
                                    <div class="gear-finder-category-name">${category['name']}</div>
                                    <div class="gear-finder-category-sort">
                                      <select data-gear-finder-category-sort>
                                        <option value="">Sort By</option>
                                        <option value="created-descending">Newest to Oldest</option>
                                        <option value="created-ascending">Oldest to Newest</option>
                                        <option value="price-ascending">Price: Low to High</option>
                                        <option value="price-descending">Price: High to Low</option>
                                        <option value="title-ascending">A-Z</option>
                                        <option value="title-descending">Z-A</option>
                                      </select>
                                    </div>
                                  </div>
                                  <div class="gear-finder-category-products">`;

            $.each(category.products, function(key, product) {
              let productHtml = getProductCardHtml(product);

              // `key == 7` - position of the banner on the results. This banner needs to be placed only on the 8-th position.
              if (_this.banners[category['name']] && key == 7) {
                let banner = _this.banners[category['name']];

                productHtml = `<div class="product-card product-banner"
                                      style="background: url(${banner.background}); background-size: cover; background-position: center;">
                                  <a href="${banner.link}" class="product-banner-wrapper" style="background: url(${banner.content}) no-repeat; background-size: contain; background-position: center;"></a>
                                </div>`;

                banner_exists = true;
              }

              products_html += productHtml;

              products_count++;
            });

            const ageGroupMatch = category.url.match(/Age%20Group_(\d+-\d+\s\w+)/);
            const ageGroup = (ageGroupMatch) ? ageGroupMatch[1] : '';

            category_link = `<div class="gear-finder-category-link">
                              <a href="/collections/${category.handle}?filter.p.m.custom.age_group=${ageGroup}" target="_blank">View All ${category['name']}</a>
                            </div>`;

            categories_html += products_html + '</div>' + category_link + '</div>';
          }
        });

        setCookie('gear_completed', 'gear-finder-complete');
      } else {
        setCookie('gear_completed', 'gear-finder-start');
      }

      _this.$gearResults.html(categories_html);

      getCustomerSubscriptions({shopifyCustomerId: customer.id}).then(function(records) {
        $.each(records, function(key, record) {
          $('.fav-button[product-id="' + record.ShopifyProductID + '"]').addClass('active');
        });
      }).catch(function() {});

      banner_exists ? _this.$gearCount.text(products_count - 1) : _this.$gearCount.text(products_count);

      if (products_count) {
        _this.$gearResultsWrapper.removeClass('no-results');
      } else {
        _this.$gearResultsWrapper.addClass('no-results');
      }

      $('body').removeClass('gear-finder-quiz-show');

      _this.searchProgress = false;

      if (_this.searchChanged) {
        _this._getResults();
      }
    });
  }
  
  _quizShow(event) {
    var _this = this;

    _this.$gearChildSelector.removeClass('open');
    _this.$gearCategorySelector.removeClass('open');

    _this.$quizH3.html('Great! Let’s add some more kids.<br> You can switch between children on the results page.');

    _this.$quizSteps.find('.quiz-step[data-step=1]').show();
    _this.$quizSteps.find('.quiz-step[data-step=2]').hide();
    _this.$quizSteps.find('.quiz-step[data-step=3]').hide();
    _this.$quizSteps.find('.quiz-step[data-step=4]').hide();
    _this.$quizSteps.find('.quiz-step[data-step=5]').hide();
    _this.$quizProgress.css('width', '25%');

    $('body').addClass('gear-finder-quiz-show');
  }
  
  _quizAddChild(event) {
    var _this = this;
    event.preventDefault();

    _this.$quizChildren.find('.quiz-child-row').removeClass('active');

    _this.$quizChildren.append('<div class="quiz-child-row active" data-index="' + _this.childrenIndex + '">'+
                                '<div class="quiz-child-name">'+
                                  '<div class="quiz-label">Child’s first name</div>'+
                                  '<input type="text" placeholder="Charlie" value="" data-gear-finder-quiz-child-input>'+
                                '</div>'+
                                '<div class="quiz-child-expecting">'+
                                  '<div class="quiz-label">Born yet? <span class="tippy" title="This will help us give you the best recommendations possible. All information provided is completely confidential."><img src="//goodbuygear.com/cdn/shop/t/354/assets/question-icon.svg?v=182271138597927344761791050004"></span></div>'+
                                  '<select type="text" placeholder="Select" data-gear-finder-quiz-child-input><option value="born">Born</option><option value="expecting">Expecting</option></select>'+
                                '</div>'+
                                '<div class="quiz-child-date">'+
                                  '<div class="quiz-label">Date of birth <span class="tippy" title="This will help us give you the best recommendations possible. All information provided is completely confidential."><img src="//goodbuygear.com/cdn/shop/t/354/assets/question-icon.svg?v=182271138597927344761791050004"></span></div>'+
                                  '<input type="text" placeholder="MM/DD/YYYY" value="" data-gear-finder-quiz-child-input>'+
                                '</div>'+
                                '<div class="quiz-child-due-date">'+
                                  '<div class="quiz-label">Due date <span class="tippy" title="This will help us give you the best recommendations possible. All information provided is completely confidential."><img src="//goodbuygear.com/cdn/shop/t/354/assets/question-icon.svg?v=182271138597927344761791050004"></span></div>'+
                                  '<input type="text" placeholder="MM/DD/YYYY" value="" data-gear-finder-quiz-child-input>'+
                                '</div>'+
                                '<div class="quiz-child-remove" data-gear-finder-quiz-child-remove>'+
                                  '<svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">'+
                                    '<path fill="#FF5B4F" fill-rule="evenodd" d="M5.306 6.5L0 1.194 1.194 0 6.5 5.306 11.806 0 13 1.194 7.694 6.5 13 11.806 11.806 13 6.5 7.694 1.194 13 0 11.806 5.306 6.5z"></path>'+
                                  '</svg>'+
                                '</div>'+
                              '</div>');

    _this.$quizChildrenNames.addClass('visible');
    _this.$quizChildrenNamesList.find('.quiz-child-name').removeClass('active');
    _this.$quizChildrenNamesList.append('<div class="quiz-child-name active" data-index="' + _this.childrenIndex + '" data-gear-finder-quiz-child-name><span>Child</span><b data-gear-finder-quiz-child-name-remove>&#10006;</b></div>');

    _this.childrenIndex++;

    $(".gear-finder-quiz .quiz-child-date input").datepicker({
      changeMonth: true,
      changeYear: true,
      dateFormat: 'mm/dd/yy',
      maxDate: "+0D"
    });

    $(".gear-finder-quiz .quiz-child-due-date input").datepicker({
      changeMonth: true,
      changeYear: true,
      dateFormat: 'mm/dd/yy',
      minDate: "+0D"
    });

    var inputElements = document.querySelectorAll(".gear-finder-quiz .quiz-child-date input, .gear-finder-quiz .quiz-child-due-date input");

    inputElements.forEach(function(input) {
      var m = new IMask(input, {
        mask: '00/00/0000'
      });
    });

    tippy('.tippy', {
      placement: 'top',
      animation: 'shift-toward',
      duration: 600,
      arrow: true,
      livePlacement: false,
      theme: 'goodbuygear--large'
    });

    _this._validateChildren();
  }
  
  _gearChildSelectorToggle(event) {
    event.preventDefault();

    $(this).parents('.gear-finder-child-selector').toggleClass('open');
  }
  
  _gearCategorySelectorToggle(event) {
    event.preventDefault();

    $(this).parents('.gear-finder-category-selector').toggleClass('open');
  }
}

if (document.querySelector('.gear-finder--section')) {
    new StaticGearFinder();
}

const tooltips = document.querySelectorAll('.tooltip');
tooltips.forEach(tooltip => {
  tooltip.addEventListener('click', () => {
    tooltip.classList.toggle('open');
  });
});
